var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __markAsModule = (target) => __defProp(target, "__esModule", { value: true });
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __reExport = (target, module2, copyDefault, desc) => {
  if (module2 && typeof module2 === "object" || typeof module2 === "function") {
    for (let key of __getOwnPropNames(module2))
      if (!__hasOwnProp.call(target, key) && (copyDefault || key !== "default"))
        __defProp(target, key, { get: () => module2[key], enumerable: !(desc = __getOwnPropDesc(module2, key)) || desc.enumerable });
  }
  return target;
};
var __toCommonJS = /* @__PURE__ */ ((cache) => {
  return (module2, temp) => {
    return cache && cache.get(module2) || (temp = __reExport(__markAsModule({}), module2, 1), cache && cache.set(module2, temp), temp);
  };
})(typeof WeakMap !== "undefined" ? /* @__PURE__ */ new WeakMap() : 0);

// src/index.ts
var src_exports = {};
__export(src_exports, {
  default: () => src_default
});

// src/keyMap.ts
var keyMap = {
  AI_CONTACTER_TEXT1: "\u60A8\u7684\u8D26\u6237\u5C1A\u672A\u914D\u7F6E\u6E20\u9053\u4FE1\u606F\uFF0C\u8BF7\u4E0E\u7279\u8D5E\u8054\u7CFB",
  AI_CONTACTER_TEXT2: "\u6B64\u6B65\u9AA4\u9700\u914D\u7F6E\u771F\u5B9E\u6E20\u9053\u8D26\u53F7\uFF0C\u8BF7\u8054\u7CFB\u72791\u8D5E",
  AI_EYE_TEXT: "Tezign.EYE \u6B63\u5728\u601D\u8003\u4E2D...",
  API_ORIGIN: "https://vms-service.tezign.com",
  API_SOCKET: "wss://vms-service.tezign.com",
  STATIC_DOMAIN: "https://static.tezign.com",
  GLOBAL_API_ORIGIN: "https://service.tezign.com",
  USER_DOMAIN: "https://id.tezign.com",
  GET_UPLOAD_FEED_URL: "https://vms-service.tezign.com/resource-center/osService/public/policy",
  GET_TENANT_CLOUD_SERVICE_PROVIDE_URL: "https://vms-service.tezign.com/resource-center/osService/public/getOsBasicInfo",
  UPLOAD_RESOURCE_URL: "https://vms-service.tezign.com/resource-center/resBaseInfo/createResource",
  PREVIEW_PAGE_FOR_3D: "https://itg-static.tezign.com/3d-viewer",
  FZSSJW: "https://tezign-static-shanghai-cdn.tezign.com/fonts/FZSSJW.TTF",
  LOADING_GIF_URL: "",
  OW365: "https://x2.ow365.cn/?i=21645&ssl=1&furl=",
  TEZIGN_WEB_TRACER_DISABLED: false,
  BUCKET_KEY_FOR_3D: "bucketKey",
  SUPPLIER_MINING_ENGINE: "\u6570\u636E\u6765\u81EA\u7279\u8D5E\u6570\u636E\u6316\u6398\u5F15\u64CE Tezign Mind",
  SUPPLIER_MINING_ENGINE_EN: "Data come from the Tezign Mind -- a data mining engine",
  ALIYUN_SDK_URL: "https://gosspublic.alicdn.com/aliyun-oss-sdk-6.8.0.min.js",
  TENCENT_SDK_URL: "https://unpkg.com/cos-js-sdk-v5/dist/cos-js-sdk-v5.min.js",
  SUPPORT_EMAIL: "support@tezign.com",
  TRACK_API: "https://track-api.tezign.com/trackEvent"
};
var keyMap_default = keyMap;

// src/index.ts
var TenantConfig = {
  config: (window == null ? void 0 : window.$config) || {},
  setValue(key, value) {
    this.config[key] = value;
  },
  value(key) {
    var _a, _b;
    if (typeof window === "undefined" && !this.config[key]) {
      console.warn("dont support get tenant-config, please setValue first");
    }
    return (_b = (_a = this.config[key]) != null ? _a : keyMap_default[key]) != null ? _b : (() => {
      console.warn(`\u3010tenant-config\u3011get ${key} value empty`);
      return "";
    })();
  }
};
var src_default = TenantConfig;
module.exports = __toCommonJS(src_exports);
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {});
